import { render, staticRenderFns } from "./des-create.vue?vue&type=template&id=fdf2d12c&scoped=true&"
import script from "./des-create.vue?vue&type=script&lang=js&"
export * from "./des-create.vue?vue&type=script&lang=js&"
import style0 from "./des-create.vue?vue&type=style&index=0&id=fdf2d12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf2d12c",
  null
  
)

export default component.exports